import {
  HTTPValidationError,
  updateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatch,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchData,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchResponse,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import studyQueryKeys from './queryKeyFactory'

export function useUpdateStudyQuery(): UseMutationResult<
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchResponse,
  AxiosError<HTTPValidationError>,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchData
> {
  return useMutation<
    UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchResponse,
    AxiosError<HTTPValidationError>,
    UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchData
  >({
    mutationFn: async (query) => {
      const response = await updateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatch({
        path: query.path,
        body: query.body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: (_data, query) => {
      queryClient.invalidateQueries({ queryKey: studyQueryKeys.list({ study_id: query.path.study_id }) })
      queryClient.invalidateQueries({
        queryKey: studyQueryKeys.detail(query.path.study_id, query.path.study_query_id),
      })
    },
  })
}
